import { UserSessionStore } from '@aon/aon-tws-common-ui';
import { connect } from 'react-redux';
import { AdminLayout } from '../../components/layout/AdminLayout';
import { SurveySummaryItemType } from '../../models';
import { IApplicationState } from '../../store';
import { NavigationActions } from '../../store/NavigationActions';
import { mapStateToProps } from './Layout';

const mapAdditionalStateToProps = (state: IApplicationState) => ({
	...mapStateToProps(state),
	...state.surveyAdmin,
	hasBeenPublished: false,
	...state.surveyAdmin.surveyAdminSummary,
	surveyName: findSurveyName(state),
});

export const AdminLayoutContainer: React.ComponentType<any> = connect(mapAdditionalStateToProps, {
	...NavigationActions,
	logout: UserSessionStore.logout,
})(AdminLayout as any);

const findSurveyName = (state: IApplicationState) => {
	if (state.surveyAdmin.surveyAdminSummary) {
		const summary = state.surveyAdmin.surveyAdminSummary.summaryItems.find((n) => n.propertyName === SurveySummaryItemType.SurveyName);
		if (summary) {
			return summary.value;
		}
	}
	return '';
};
